/**
 * Is a persisted Heritage stock/price reading stale? (ESERV2-1442, Q7′)
 *
 * The daily cron keeps readings at most ~24h old, so anything older than 36
 * hours means the refresh missed a beat and the number on screen should say
 * so. A missing timestamp is stale by definition: it has never been read.
 * PO-time surfaces refresh live (ESERV2-1435) and do not rely on this.
 */
export const STALE_READING_HOURS = 36;

export function isStaleReading(lastUpdate, now = new Date()) {
  if (!lastUpdate) return true;
  const then = new Date(lastUpdate);
  if (Number.isNaN(then.getTime())) return true;
  return now.getTime() - then.getTime() > STALE_READING_HOURS * 60 * 60 * 1000;
}
